
import React, {
    useEffect,
    useState,
    useRef,
} from "react";
import {
    Row,
    Col,

} from "../../ui/ot";

import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from "../../ui/card"
import { ColumnChart } from "./column_chart"
import { BarGraghChart } from './bar_graph_chart'
import { StackedColumnChart } from './stacked_column_chart'
import { GroupColumnChart } from './grouped_column_chart'
import { LineBasicChart } from "./line_basic_chart";
import { PieBasicChart } from "./pie_basic_chart"
import { DonutChart } from './donut_chart'
import { RadarBasicChart } from './radar_basic_chart'
import { ProjectChart, ButterflyChart } from './project_chart'
import Divider from '../../ui/divider'
import StatsCardDemo from './stats_card_demo'
const chartData = [
    { month: "January", desktop: 186, mobile: 80 },
    { month: "February", desktop: 305, mobile: 200 },
    { month: "March", desktop: 237, mobile: 120 },
    { month: "April", desktop: 73, mobile: 190 },
    { month: "May", desktop: 209, mobile: 130 },
    { month: "June", desktop: 214, mobile: 140 },
]

const chartConfig = {
    desktop: {
        label: "Desktop",
        color: "#2563eb",
    },
    mobile: {
        label: "Mobile",
        color: "#60a5fa",
    },
}
const ChartOverview = () => {
    return <Row>
        <Col span={24}>
            <Row gutter={[8, 8]}>

                <Col span={24}>
                    <Divider >StatsCardDemo</Divider>
                    <StatsCardDemo />
                </Col>
                <Col span={24}>
                    {/* <ButterflyChart /> */}
                </Col>
                <Col span={24}>
                    {/* <ProjectChart /> */}
                </Col>
                <Col span={6}>
                    <Card>
                        <CardHeader>
                            <CardTitle>有標籤的直條圖 </CardTitle>
                            <CardDescription>January - June 2024</CardDescription>
                        </CardHeader>
                        <CardContent>
                            <ColumnChart
                                //數值類型的key
                                chartConfig={{
                                    desktop: {
                                        label: "桌機",
                                        color: "hsl(var(--chart-1))",
                                    },
                                }}
                                //data
                                chartData={[
                                    { month: "January", desktop: 186 },
                                    { month: "February", desktop: 305 },
                                    { month: "March", desktop: 237 },
                                    { month: "April", desktop: 73 },
                                    { month: "May", desktop: 209 },
                                    { month: "June", desktop: 214 },
                                ]}
                                //X 軸顯示的名稱的key
                                xDataKeyArr={["month"]}
                                //Y 軸顯示的名稱得key
                                yDataKeyArr={["desktop"]}
                                //要不要顯示標籤在頂部
                                showLabel={true}
                            />
                        </CardContent>
                        <CardFooter className="flex-col items-start gap-2 text-sm">
                            <div className="flex gap-2 font-medium leading-none">
                                Trending up by 5.2% this month
                            </div>
                            <div className="leading-none text-muted-foreground">
                                Showing total visitors for the last 6 months
                            </div>
                        </CardFooter>
                    </Card>

                </Col>
                <Col span={6}>
                    <Card>
                        <CardHeader>
                            <CardTitle>沒有標籤的直條圖</CardTitle>
                            <CardDescription>January - June 2024</CardDescription>
                        </CardHeader>
                        <CardContent>
                            <ColumnChart
                                //數值類型的key
                                chartConfig={{
                                    desktop: {
                                        label: "桌機",
                                        color: "hsl(var(--chart-1))",
                                    },
                                }}
                                //data
                                chartData={[
                                    { month: "January", desktop: 186 },
                                    { month: "February", desktop: 305 },
                                    { month: "March", desktop: 237 },
                                    { month: "April", desktop: 73 },
                                    { month: "May", desktop: 209 },
                                    { month: "June", desktop: 214 },
                                ]}
                                //X 軸顯示的名稱的key
                                xDataKeyArr={["month"]}
                                //要不要顯示標籤在頂部
                                showLabel={false}
                                //Y 軸顯示的名稱得key
                                yDataKeyArr={["desktop"]}
                            />
                        </CardContent>
                        <CardFooter className="flex-col items-start gap-2 text-sm">
                            <div className="flex gap-2 font-medium leading-none">
                                Trending up by 5.2% this month
                            </div>
                            <div className="leading-none text-muted-foreground">
                                Showing total visitors for the last 6 months
                            </div>
                        </CardFooter>
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <CardHeader>
                            <CardTitle>沒有標籤的橫條圖</CardTitle>
                            <CardDescription>January - June 2024</CardDescription>
                        </CardHeader>
                        <CardContent>
                            <BarGraghChart
                                //數值類型的key
                                chartConfig={{
                                    desktop: {
                                        label: "桌機",
                                        color: "hsl(var(--chart-1))",
                                    },
                                }}
                                //data
                                chartData={[
                                    { month: "January", desktop: 186 },
                                    { month: "February", desktop: 305 },
                                    { month: "March", desktop: 237 },
                                    { month: "April", desktop: 73 },
                                    { month: "May", desktop: 209 },
                                    { month: "June", desktop: 214 },
                                ]}
                                //X 軸顯示的名稱的key
                                xType="number"
                                //要不要顯示標籤在頂部
                                showLabel={false}
                                //X 軸顯示的名稱得key
                                xDataKeyArr={["desktop"]}
                                //Y 軸顯示的名稱得key
                                yDataKeyArr={["month"]}
                            />
                        </CardContent>
                        <CardFooter className="flex-col items-start gap-2 text-sm">
                            <div className="flex gap-2 font-medium leading-none">
                                Trending up by 5.2% this month
                            </div>
                            <div className="leading-none text-muted-foreground">
                                Showing total visitors for the last 6 months
                            </div>
                        </CardFooter>
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <CardHeader>
                            <CardTitle>有標籤的橫條圖</CardTitle>
                            <CardDescription>January - June 2024</CardDescription>
                        </CardHeader>
                        <CardContent>
                            <BarGraghChart
                                //數值類型的key
                                chartConfig={{
                                    desktop: {
                                        label: "桌機",
                                        color: "hsl(var(--chart-1))",
                                    },
                                }}
                                //data
                                chartData={[
                                    { month: "January", desktop: 186 },
                                    { month: "February", desktop: 305 },
                                    { month: "March", desktop: 237 },
                                    { month: "April", desktop: 73 },
                                    { month: "May", desktop: 209 },
                                    { month: "June", desktop: 214 },
                                ]}
                                //X 軸顯示的名稱的key
                                xType="number"
                                //要不要顯示標籤在頂部
                                showLabel={true}
                                //X 軸顯示的名稱得key
                                xDataKeyArr={["desktop"]}
                                //Y 軸顯示的名稱得key
                                yDataKeyArr={["month"]}
                            />
                        </CardContent>
                        <CardFooter className="flex-col items-start gap-2 text-sm">
                            <div className="flex gap-2 font-medium leading-none">
                                Trending up by 5.2% this month
                            </div>
                            <div className="leading-none text-muted-foreground">
                                Showing total visitors for the last 6 months
                            </div>
                        </CardFooter>
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <CardHeader>
                            <CardTitle>堆疊長條圖 </CardTitle>
                            <CardDescription>January - June 2024</CardDescription>
                        </CardHeader>
                        <CardContent>
                            <StackedColumnChart
                                //key 的 標籤及顯示顏色設定
                                chartConfig={{
                                    desktop: {
                                        label: "Desktop",
                                        color: "hsl(var(--chart-1))",
                                    },
                                    mobile: {
                                        label: "Mobile",
                                        color: "hsl(var(--chart-2))",
                                    },
                                }}
                                //data
                                chartData={[
                                    { month: "January", desktop: 186, mobile: 80 },
                                    { month: "February", desktop: 305, mobile: 200 },
                                    { month: "March", desktop: 237, mobile: 120 },
                                    { month: "April", desktop: 73, mobile: 190 },
                                    { month: "May", desktop: 209, mobile: 130 },
                                    { month: "June", desktop: 214, mobile: 140 },
                                ]}
                                //X 軸顯示的名稱得key
                                xDataKeyArr={["month"]}
                                //Y 軸顯示的名稱得key
                                yDataKeyArr={["desktop", 'mobile']}
                            />
                        </CardContent>
                        <CardFooter className="flex-col items-start gap-2 text-sm">
                            <div className="flex gap-2 font-medium leading-none">
                                Trending up by 5.2% this month
                            </div>
                            <div className="leading-none text-muted-foreground">
                                Showing total visitors for the last 6 months
                            </div>
                        </CardFooter>
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <CardHeader>
                            <CardTitle>分組長條圖</CardTitle>
                            <CardDescription>January - June 2024</CardDescription>
                        </CardHeader>
                        <CardContent>
                            <GroupColumnChart
                                //數值類型的key
                                chartConfig={{
                                    desktop: {
                                        label: "Desktop",
                                        color: "hsl(var(--chart-1))",
                                    },
                                    mobile: {
                                        label: "Mobile",
                                        color: "hsl(var(--chart-2))",
                                    },
                                }}
                                //data
                                chartData={[
                                    { month: "January", desktop: 186, mobile: 80 },
                                    { month: "February", desktop: 305, mobile: 200 },
                                    { month: "March", desktop: 237, mobile: 120 },
                                    { month: "April", desktop: 73, mobile: 190 },
                                    { month: "May", desktop: 209, mobile: 130 },
                                    { month: "June", desktop: 214, mobile: 140 },
                                ]}
                                //X 軸顯示的名稱得key
                                xdataKey={"month"}
                            />
                        </CardContent>
                        <CardFooter className="flex-col items-start gap-2 text-sm">
                            <div className="flex gap-2 font-medium leading-none">
                                Trending up by 5.2% this month
                            </div>
                            <div className="leading-none text-muted-foreground">
                                Showing total visitors for the last 6 months
                            </div>
                        </CardFooter>
                    </Card>
                </Col>
                <Col span={24}>
                    <Divider >折線圖</Divider>
                </Col>
                <Col span={6}>
                    <Card>
                        <CardHeader>
                            <CardTitle>折線圖 </CardTitle>
                            <CardDescription>January - June 2024</CardDescription>
                        </CardHeader>
                        <CardContent>
                            <LineBasicChart
                                //key 的 標籤及顯示顏色設定
                                chartConfig={{
                                    desktop: {
                                        label: "Desktop",
                                        color: "hsl(var(--chart-1))",
                                    },
                                    mobile: {
                                        label: "Mobile",
                                        color: "hsl(var(--chart-2))",
                                    },
                                }}
                                //data
                                chartData={[
                                    { month: "January", desktop: 186, mobile: 80 },
                                    { month: "February", desktop: 305, mobile: 200 },
                                    { month: "March", desktop: 237, mobile: 120 },
                                    { month: "April", desktop: 73, mobile: 190 },
                                    { month: "May", desktop: 209, mobile: 130 },
                                    { month: "June", desktop: 214, mobile: 140 },
                                ]}
                                //X 軸顯示的名稱得key
                                xDataKeyArr={["month"]}
                                //Y 軸顯示的名稱得key
                                yDataKeyArr={["desktop", 'mobile']} //幾條線
                                //在線上顯示數值
                                showLabel={true} //true false
                                //在線上標出點
                                showDot={true} //true false
                                //線的種類
                                lineType="linear" // "natural" 、"linear"、 "step"
                            />
                        </CardContent>
                        <CardFooter className="flex-col items-start gap-2 text-sm">
                            <div className="flex gap-2 font-medium leading-none">
                                Trending up by 5.2% this month
                            </div>
                            <div className="leading-none text-muted-foreground">
                                Showing total visitors for the last 6 months
                            </div>
                        </CardFooter>
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <CardHeader>
                            <CardTitle>折線圖 </CardTitle>
                            <CardDescription>January - June 2024</CardDescription>
                        </CardHeader>
                        <CardContent>
                            <LineBasicChart
                                //key 的 標籤及顯示顏色設定
                                chartConfig={{
                                    desktop: {
                                        label: "Desktop",
                                        color: "hsl(var(--chart-1))",
                                    },
                                    mobile: {
                                        label: "Mobile",
                                        color: "hsl(var(--chart-2))",
                                    },
                                }}
                                //data
                                chartData={[
                                    { month: "January", desktop: 186, mobile: 80 },
                                    { month: "February", desktop: 305, mobile: 200 },
                                    { month: "March", desktop: 237, mobile: 120 },
                                    { month: "April", desktop: 73, mobile: 190 },
                                    { month: "May", desktop: 209, mobile: 130 },
                                    { month: "June", desktop: 214, mobile: 140 },
                                ]}
                                //X 軸顯示的名稱得key
                                xDataKeyArr={["month"]}
                                //Y 軸顯示的名稱得key
                                yDataKeyArr={["desktop", 'mobile']} //幾條線
                                //在線上顯示數值
                                showLabel={true} //true false
                                //在線上標出點
                                showDot={true} //true false
                                //線的種類
                                lineType="natural" // "natural" 、"linear"、 "step"
                            />
                        </CardContent>
                        <CardFooter className="flex-col items-start gap-2 text-sm">
                            <div className="flex gap-2 font-medium leading-none">
                                Trending up by 5.2% this month
                            </div>
                            <div className="leading-none text-muted-foreground">
                                Showing total visitors for the last 6 months
                            </div>
                        </CardFooter>
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <CardHeader>
                            <CardTitle>折線圖 </CardTitle>
                            <CardDescription>January - June 2024</CardDescription>
                        </CardHeader>
                        <CardContent>
                            <LineBasicChart
                                //key 的 標籤及顯示顏色設定
                                chartConfig={{
                                    desktop: {
                                        label: "Desktop",
                                        color: "hsl(var(--chart-1))",
                                    },
                                    mobile: {
                                        label: "Mobile",
                                        color: "hsl(var(--chart-2))",
                                    },
                                }}
                                //data
                                chartData={[
                                    { month: "January", desktop: 186, mobile: 80 },
                                    { month: "February", desktop: 305, mobile: 200 },
                                    { month: "March", desktop: 237, mobile: 120 },
                                    { month: "April", desktop: 73, mobile: 190 },
                                    { month: "May", desktop: 209, mobile: 130 },
                                    { month: "June", desktop: 214, mobile: 140 },
                                ]}
                                //X 軸顯示的名稱得key
                                xDataKeyArr={["month"]}
                                //Y 軸顯示的名稱得key
                                yDataKeyArr={["desktop"]} //幾條線
                                //在線上顯示數值
                                showLabel={true} //true false
                                //在線上標出點
                                showDot={true} //true false
                                //線的種類
                                lineType="step" // "natural" 、"linear"、 "step"
                            />
                        </CardContent>
                        <CardFooter className="flex-col items-start gap-2 text-sm">
                            <div className="flex gap-2 font-medium leading-none">
                                Trending up by 5.2% this month
                            </div>
                            <div className="leading-none text-muted-foreground">
                                Showing total visitors for the last 6 months
                            </div>
                        </CardFooter>
                    </Card>
                </Col>
                <Col span={24}>
                    <Divider >圓餅圖</Divider>
                </Col>
                <Col span={6}>
                    <Card>
                        <CardHeader>
                            <CardTitle>圓餅圖 </CardTitle>
                            <CardDescription>January - June 2024</CardDescription>
                        </CardHeader>
                        <CardContent>
                            <PieBasicChart
                                //數值類型的key
                                chartConfig={{
                                    visitors: {
                                        label: "Visitors",
                                    },
                                    chrome: {
                                        label: "Chrome",
                                        color: "hsl(var(--chart-1))",
                                    },
                                    safari: {
                                        label: "Safari",
                                        color: "hsl(var(--chart-2))",
                                    },
                                    firefox: {
                                        label: "Firefox",
                                        color: "hsl(var(--chart-3))",
                                    },
                                    edge: {
                                        label: "Edge",
                                        color: "hsl(var(--chart-4))",
                                    },
                                    other: {
                                        label: "Other",
                                        color: "hsl(var(--chart-5))",
                                    },
                                }}
                                //data
                                chartData={[
                                    { browser: "chrome", visitors: 275, },
                                    { browser: "safari", visitors: 200, },
                                    { browser: "firefox", visitors: 187, },
                                    { browser: "edge", visitors: 173, },
                                    { browser: "other", visitors: 90, },
                                ]}
                                //X 軸顯示的名稱得key
                                xDataKeyArr={["browser"]} //only one
                                yDataKeyArr={["visitors"]}//only one
                                showLabel={true}
                                labelType={"inner"}//  inner, outer,
                                showLegend={true}
                            />
                        </CardContent>
                        <CardFooter className="flex-col items-start gap-2 text-sm">
                            <div className="flex gap-2 font-medium leading-none">
                                Trending up by 5.2% this month
                            </div>
                            <div className="leading-none text-muted-foreground">
                                Showing total visitors for the last 6 months
                            </div>
                        </CardFooter>
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <CardHeader>
                            <CardTitle>甜甜圈圖 </CardTitle>
                            <CardDescription>January - June 2024</CardDescription>
                        </CardHeader>
                        <CardContent>
                            <DonutChart
                                chartConfig={{
                                    visitors: {
                                        label: "Visitors",
                                    },
                                    chrome: {
                                        label: "Chrome",
                                        color: "hsl(var(--chart-1))",
                                    },
                                    safari: {
                                        label: "Safari",
                                        color: "hsl(var(--chart-2))",
                                    },
                                    firefox: {
                                        label: "Firefox",
                                        color: "hsl(var(--chart-3))",
                                    },
                                    edge: {
                                        label: "Edge",
                                        color: "hsl(var(--chart-4))",
                                    },
                                    other: {
                                        label: "Other",
                                        color: "hsl(var(--chart-5))",
                                    },
                                }}
                                //data
                                chartData={[
                                    { browser: "chrome", visitors: 275, },
                                    { browser: "safari", visitors: 200, },
                                    { browser: "firefox", visitors: 187, },
                                    { browser: "edge", visitors: 173, },
                                    { browser: "other", visitors: 90, },
                                ]}
                                //X 軸顯示的名稱得key
                                xDataKeyArr={["browser"]} //only one
                                yDataKeyArr={["visitors"]}//only one
                                showLabel={true}
                                labelType={"inner"}//  inner, outer,
                                showLegend={true}
                                innerRadius={40}
                            />
                        </CardContent>
                        <CardFooter className="flex-col items-start gap-2 text-sm">
                            <div className="flex gap-2 font-medium leading-none">
                                Trending up by 5.2% this month
                            </div>
                            <div className="leading-none text-muted-foreground">
                                Showing total visitors for the last 6 months
                            </div>
                        </CardFooter>
                    </Card>
                </Col>
                <Col span={24}>
                    <Divider >雷達圖</Divider>
                </Col>
                <Col span={6}>
                    <Card>
                        <CardHeader>
                            <CardTitle>雷達圖 </CardTitle>
                            <CardDescription>January - June 2024</CardDescription>
                        </CardHeader>
                        <CardContent>
                            <RadarBasicChart />
                        </CardContent>
                        <CardFooter className="flex-col items-start gap-2 text-sm">
                            <div className="flex gap-2 font-medium leading-none">
                                Trending up by 5.2% this month
                            </div>
                            <div className="leading-none text-muted-foreground">
                                Showing total visitors for the last 6 months
                            </div>
                        </CardFooter>
                    </Card>
                </Col>


            </Row>

        </Col>

    </Row>
}

export { ChartOverview, ColumnChart, BarGraghChart, StackedColumnChart, GroupColumnChart, LineBasicChart, PieBasicChart, DonutChart, RadarBasicChart }





